"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SENTRY_BOOKINGS_WIDGET_DSN = exports.FEDOPS_MAIN_PAGE_WIDGET_EDITOR = exports.FEDOPS_SERVICES_LIST_WIDGET_EDITOR = void 0;
exports.FEDOPS_SERVICES_LIST_WIDGET_EDITOR = 'bookings-services-widget-editor';
exports.FEDOPS_MAIN_PAGE_WIDGET_EDITOR = 'bookings-main-page-widget-editor';
exports.SENTRY_BOOKINGS_WIDGET_DSN = 'https://487dbfbf210c492cac29cec41461385a@sentry.wixpress.com/173';
//# sourceMappingURL=bookings.const.js.map